(function () {
function $(s, r) { return (r || document).querySelector(s); }
function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
function money(c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); }
function refresh() {
return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
.then(function (r) { return r.json(); })
.then(function (c) {
$$('[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; });
$$('[data-cart-total]').forEach(function (e) { e.textContent = money(c.total_price); });
return c;
});
}
document.addEventListener('submit', function (e) {
var f = e.target;
if (!f.matches || !f.matches('[data-add-form]')) return;
e.preventDefault();
var btn = f.querySelector('button[type=submit]');
var orig = btn.textContent;
btn.disabled = true;
fetch(root() + 'cart/add.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
.then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
.then(function () {
btn.textContent = 'Added';
refresh();
setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1200);
})
.catch(function () { f.submit(); });
});
function tick() {
$$('[data-countdown]').forEach(function (box) {
var target = new Date(box.getAttribute('data-countdown'));
var cap = $('[data-cd-cap]', box.parentNode);
var ms = target - new Date();
if (isNaN(ms)) return;
if (ms <= 0) {
box.style.display = 'none';
if (cap) cap.textContent = box.getAttribute('data-open-text') || '';
return;
}
var m = Math.floor(ms / 60000);
var d = $('[data-cd-d]', box), h = $('[data-cd-h]', box), mm = $('[data-cd-m]', box);
if (d) d.textContent = Math.floor(m / 1440);
if (h) h.textContent = Math.floor((m % 1440) / 60);
if (mm) mm.textContent = m % 60;
});
}
tick(); setInterval(tick, 30000);
var form = $('[data-cart-form]');
if (form) {
document.addEventListener('click', function (e) {
var b = e.target.closest('[data-step]');
if (!b) return;
var input = $('input[name="updates[]"]', b.closest('.citem'));
var v = parseInt(input.value, 10) + parseInt(b.getAttribute('data-step'), 10);
input.value = Math.max(0, v);
var upd = $('[data-update]', form);
if (upd) upd.click(); else form.submit();
});
var pick = $('[data-pickup]');
if (pick) {
var rules = {};
(pick.getAttribute('data-hours') || '').split(';').forEach(function (r) {
var m = r.trim().match(/^(\d):(\d+)-(\d+)$/);
if (m) rules[m[1]] = { o: +m[2], c: +m[3] };
});
var date = $('[data-pickup-date]', pick), time = $('[data-pickup-time]', pick), err = $('[data-pickup-err]', pick);
var hoursFor = function (iso) {
var p = iso.split('-');
return rules[new Date(+p[0], +p[1] - 1, +p[2]).getDay()] || null;
};
var fmt = function (m) {
var h = Math.floor(m / 60), mm = m % 60, ap = h >= 12 ? 'pm' : 'am';
h = h % 12 || 12;
return h + ':' + (mm < 10 ? '0' : '') + mm + ' ' + ap;
};
date.addEventListener('change', function () {
err.textContent = '';
if (!date.value) { time.disabled = true; time.innerHTML = '<option value="">Choose a day first</option>'; return; }
var h = hoursFor(date.value);
if (!h) {
time.disabled = true;
time.innerHTML = '<option value="">Closed that day</option>';
err.textContent = pick.getAttribute('data-closed-msg') || 'We are closed that day.';
return;
}
var o = '<option value="">Choose a time</option>';
for (var m = h.o * 60; m <= h.c * 60 - 30; m += 30) o += '<option>' + fmt(m) + '</option>';
time.innerHTML = o; time.disabled = false;
});
form.addEventListener('submit', function (e) {
var s = e.submitter;
if (!s || s.name !== 'checkout') return;
var msg = '';
if (!date.value) msg = 'Choose a pickup day.';
else if (!hoursFor(date.value)) msg = pick.getAttribute('data-closed-msg') || 'We are closed that day.';
else if (!time.value) msg = 'Choose a pickup time.';
if (msg) { e.preventDefault(); err.textContent = msg; }
});
}
}
})();
